export default __webpack_public_path__ + "static/media/autopart-shopping-cart.a781e7d3.png";